module.exports = __webpack_public_path__ + "static/media/icon-dev-ic-help.770bd366.svg";